module.exports = __webpack_public_path__ + "img/ctn_checkbox_checked.b810e385.svg";